import React from "react"
import { useTranslation } from "react-i18next"
import { Form } from 'react-final-form'

import { withPopin, Popin, FormError } from '@portal/kit/pkg/components'

import UnsubscribeForm from "./unsubscribe-form"
import unsubscribeValidator from "validators/unsubscribe-validator"

function UnsubscribePopin({ popin, opened, cancel, unsubscribe, popinError }) {
  const { t } = useTranslation()
  const isLoading = false

  const popinProps = {
    ...popin,
    isOpened: opened,
    close: cancel
  }

  const submitForm = ({ resiliation_date }) => {
    unsubscribe(resiliation_date)
  }

  return (
    <Popin title={t("subscription.resiliation.title")} {...popinProps}>
      {popinError && <FormError message={popinError} />}
      <Form
        validate={unsubscribeValidator}
        cancel={cancel}
        isLoading={isLoading}
        onSubmit={submitForm}
        render={formProps => <UnsubscribeForm {...formProps} />}
      />
    </Popin>
  )
}

export default withPopin(UnsubscribePopin)
